<div class="my-modal">
    <ng-container>
        <h4 class="titleModal">{{'event_reserv.title' | translate}} {{data.event_name}}</h4>
        <mat-dialog-content>
            <mat-table [dataSource]="dataSource" class="mat-elevation-z8">
              @for (column of columns; track column.columnDef) {
                <ng-container [matColumnDef]="column.columnDef">
                  <mat-header-cell *matHeaderCellDef> {{column.header | translate}} </mat-header-cell>
                  <mat-cell *matCellDef="let row">
                    <span class="mobile-label">{{column.header | translate}}:</span>
                    {{column.cell(row)}}
                  </mat-cell>
                </ng-container>
              }

                <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{'event_reserv.status' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index">
                        <span class="mobile-label">{{'event_reserv.status' | translate}}:</span>
                      @if (element.is_waiting_list == 1) {
                        <div >{{'event_reserv.inwl' | translate}}</div>
                      }
                      @if (element.is_waiting_list == 0) {
                        <div >{{'event_reserv.reservconf' | translate}}</div>
                      }
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="can_edit">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{'event_reserv.gest' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index">
                        <span class="mobile-label">{{'event_reserv.gest' | translate}}:</span>
                      @if (data.associated_reservations[i].is_editable) {
                        <a class="icon-edit" (click)="edit(i)" >
                          <mat-icon svgIcon="edit" aria-hidden="false"></mat-icon>
                        </a>
                      }
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="download">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{'event_reserv.ticket' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index">
                        <span class="mobile-label">{{'event_reserv.ticket' | translate}}:</span>
                        <a class="icon-download" (click)="download(i)" [hidden]="data.associated_reservations[i].is_waiting_list == 1">
                            <mat-icon svgIcon="download" aria-hidden="false"></mat-icon>
                        </a>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="numeroPasseggeri">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{'event_reserv.num_pass' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element; let i = index">
                        <span class="mobile-label">{{'event_reserv.num_pass' | translate}}:</span>
                        {{element.number_of_users}}
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
        </mat-dialog-content>
    </ng-container>

    <div class="mini-button-container">
        <button class="mini-button annulla" (click)="close()">{{'close'|translate}}</button>
    </div>
</div>
